import spiralDev from "../../assets/SpiralDevelopment.jpg"
import headerImage from "../../assets/header4.jpg"

const Assignment18 = () => {
    return (
      <div className="container mx-auto my-8 px-5 max-w-3xl bg-gray-100 p-8 rounded-lg shadow-md">
      {/* Header */}
      <div className="relative mb-8">
        <img
          src={headerImage}
          alt="Header"
          className="w-full h-64 object-cover rounded-lg shadow-md  object-cover filter grayscale brightness-75"
        />
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent p-4 rounded-b-lg">
          <h1 className="text-4xl font-bold text-bg-secondary"  style={{ textShadow: '2px 2px 4px rgba(0, 0, 0, 1)' }}>Week 17: Applications and Implications</h1>
          <h1 className="text-xl font-bold text-bg-secondary"  style={{ textShadow: '2px 2px 4px rgba(0, 0, 0, 1)' }}>Project Development</h1>
          <p className="text-gray-300 mt-2">Published on: <span className="font-semibold">June 03, 2025</span></p>
          <div className="mt-4 flex space-x-4">
            
            </div>
            </div>
            </div>

<h3 className="text-2xl font-bold text-left mb-4">Project Summary</h3>
<p className="text-justify text-gray-700 mb-6">
  My final project is a companion robot named <strong>Robo-Buddy</strong>, which follows its owner and can carry items. It integrates mechanical construction, electronics design, embedded systems, and digital fabrication techniques.
   The robot includes remote control functionality and sensor-based obstacle detection and will serve as a modular base for future expansions like autonomous behaviors.
</p>

<h3 className="text-2xl font-bold text-left mb-4">What will it do?</h3>
<p className="text-justify text-gray-700 mb-6">
  The robot will follow its user, avoid obstacles, and transport personal belongings. It uses stepper motors, ultrasonic sensors, and wireless communication (WiFi). It is controlled via a mobile app and features modular construction for upgrades.
</p>

<h3 className="text-2xl font-bold text-left mb-4">Who has done what beforehand?</h3>
<p className="text-justify text-gray-700 mb-6">
  Projects such as R2D2 builds or autonomous delivery robots have inspired this concept. However, <strong>Robo-Buddy</strong> aims to combine practical mobility with modular extensibility using digital fabrication techniques and low-cost electronics.
</p>

<h3 className="text-2xl font-bold text-left mb-4">What will you design?</h3>
<ul className="list-disc pl-6 text-gray-700 mb-6">
  <li>Chassis (top & bottom plate – laser cut from aluminum)</li>
  <li>Bearing blocks and mounts (3D printed)</li>
  <li>Electronics PCBs for motor drivers and ultrasonic sensors</li>
  <li>3D printed housing and dome for aesthetic design</li>
  <li>Mobile App for basic control</li>
</ul>

<h3 className="text-2xl font-bold text-left mb-4">What materials and components will be used and how much will they cost?</h3>
<h3 className="text-2xl font-bold text-left mb-4">Bill of Materials (BOM)</h3>
<table className="table-auto w-full text-left border border-gray-300 mb-6">
  <thead>
    <tr className="bg-gray-200">
      <th className="px-4 py-2">Item</th>
      <th className="px-4 py-2">Quantity</th>
      <th className="px-4 py-2">Source</th>
      <th className="px-4 py-2">Estimated Cost (€)</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td className="border px-4 py-2">Copper-clad PCB sheets</td>
      <td className="border px-4 py-2">2 sheets</td>
      <td className="border px-4 py-2">Lab stock</td>
      <td className="border px-4 py-2">0</td>
    </tr>
    <tr>
      <td className="border px-4 py-2">Aluminum plate (top & bottom chassis)</td>
      <td className="border px-4 py-2">1 plate</td>
      <td className="border px-4 py-2">Lab stock</td>
      <td className="border px-4 py-2">0</td>
    </tr>
    <tr>
      <td className="border px-4 py-2">6 cm steel rod (wheel axle)</td>
      <td className="border px-4 py-2">1 rod</td>
      <td className="border px-4 py-2">Lab stock</td>
      <td className="border px-4 py-2">0</td>
    </tr>
    <tr>
      <td className="border px-4 py-2">3D printing filament (PETG)</td>
      <td className="border px-4 py-2">500g</td>
      <td className="border px-4 py-2">Lab stock</td>
      <td className="border px-4 py-2">0</td>
    </tr>
    <tr>
      <td className="border px-4 py-2">2x NEMA 17 stepper motors</td>
      <td className="border px-4 py-2">2</td>
      <td className="border px-4 py-2">Reichelt</td>
      <td className="border px-4 py-2">21</td>
    </tr>
    <tr>
      <td className="border px-4 py-2">Motor driver (e.g. DRV8825)</td>
      <td className="border px-4 py-2">2</td>
      <td className="border px-4 py-2">Reichelt</td>
      <td className="border px-4 py-2">11</td>
    </tr>
    <tr>
      <td className="border px-4 py-2">ESP32 microcontroller (XIAO ESP32S3Plus)</td>
      <td className="border px-4 py-2">3</td>
      <td className="border px-4 py-2">Reichelt</td>
      <td className="border px-4 py-2">10</td>
    </tr>
    <tr>
      <td className="border px-4 py-2">Ultrasonic sensors (2x HC-SR04)</td>
      <td className="border px-4 py-2">2</td>
      <td className="border px-4 py-2">Reichelt</td>
      <td className="border px-4 py-2">4</td>
    </tr>
    <tr>
      <td className="border px-4 py-2">Battery pack (Li-Ion or LiPo)</td>
      <td className="border px-4 py-2">1</td>
      <td className="border px-4 py-2">eBay</td>
      <td className="border px-4 py-2">25</td>
    </tr>
    <tr>
      <td className="border px-4 py-2">Wheels with belt pulleys</td>
      <td className="border px-4 py-2">2</td>
      <td className="border px-4 py-2">eBay</td>
      <td className="border px-4 py-2">20</td>
    </tr>
    <tr>
      <td className="border px-4 py-2">SMD Components</td>
      <td className="border px-4 py-2">Various</td>
      <td className="border px-4 py-2">Reichelt</td>
      <td className="border px-4 py-2">15</td>
    </tr>
    <tr>
      <td className="border px-4 py-2">Timing belts</td>
      <td className="border px-4 py-2">2</td>
      <td className="border px-4 py-2">Zahnriehmen24</td>
      <td className="border px-4 py-2">8</td>
    </tr>
    <tr>
      <td className="border px-4 py-2">Ball bearings</td>
      <td className="border px-4 py-2">4</td>
      <td className="border px-4 py-2">eBay</td>
      <td className="border px-4 py-2">6</td>
    </tr>
    
    <tr>
      <td className="border px-4 py-2">Screws, nuts, spacers</td>
      <td className="border px-4 py-2">Various</td>
      <td className="border px-4 py-2">Hornbach</td>
      <td className="border px-4 py-2">10</td>
    </tr>
  </tbody>
</table>



<h3 className="text-2xl font-bold text-left mb-4">Where will they come from?</h3>
<p className="text-justify text-gray-700 mb-6">
  A combination of locally available materials and online-sourced components will be used in this project. Copper-clad PCB sheets, the aluminum plate for the chassis, and the steel rod used for the wheel axle were sourced from the Fab Lab inventory. Components like the NEMA 17 stepper motors, motor driver modules, ultrasonic sensors, XIAO ESP32S3Plus and cables were sourced from Reichelt Elektronik. 
  This approach helps balance cost-efficiency with component availability and reuse of existing lab stock wherever possible.
</p>


<h3 className="text-2xl font-bold text-left mb-4">How much will they cost?</h3>
<p className="text-justify text-gray-700 mb-6">
  The estimated cost is around <strong>150€ - 250€ </strong>, including all electronic parts and structural materials.
</p>

<h3 className="text-2xl font-bold text-left mb-4">What parts and systems will be made?</h3>
<ul className="list-disc pl-6 text-gray-700 mb-6">
  <li>Metal chassis (laser cut)</li>
  <li>3D printed bearing blocks</li>
  <li>Customized wheels with timing belt wheels made for heavy duty </li>
  <li>3D printed components: mounts, dome, enclosure</li>
  <li>Custom PCBs for motor drivers and sensors</li>
  <li>Mobile control app and embedded firmware</li>
</ul>

<h3 className="text-2xl font-bold text-left mb-4">What processes will be used?</h3>
<ul className="list-disc pl-6 text-gray-700 mb-6">
  <li>2D Design (Inkscape, Fusion 360)</li>
  <li>3D Design (Fusion 360)</li>
  <li>3D Printing (FDM)</li>
  <li>Laser Cutting (Metal & Acrylic)</li>
  <li>Electronics design and milling (KiCad)</li>
  <li>Microcontroller programming (Arduino IDE, ESP32)</li>
  <li>App programming (MIT App Inventor)</li>
</ul>

<h3 className="text-2xl font-bold text-left mb-4">What questions need to be answered?</h3>
<ul className="list-disc pl-6 text-gray-700 mb-6">
  <li>How can I ensure stable communication between modules?</li>
  <li>What is the optimal power source for long runtime?</li>
  <li>Will my mechanical design withstand the weight?</li>
  <li>Will the application be able to control the robot precisely?</li>
  <li>Can the mobile app be expanded for gesture or voice control?</li>
</ul>

<h3 className="text-2xl font-bold text-left mb-4">How will it be evaluated?</h3>
<ul className="list-disc pl-6 text-gray-700 mb-6">
  <li>Can avoid obstacles using ultrasonic sensors</li>
  <li>Moves forward/backward and turns smoothly</li>
  <li>3D printed housing fits correctly and looks clean</li>
  <li>Electronics are safe and modularly integrated</li>
</ul>




<h3 className="text-2xl font-bold text-left mb-4">Progress Overview</h3>

<div className="overflow-x-auto mb-8">
  <table className="min-w-full bg-white border border-gray-300 text-left">
    <thead>
      <tr className="bg-gray-200">
        <th className="py-2 px-4 border-b">Task</th>
        <th className="py-2 px-4 border-b">Status</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td className="py-2 px-4 border-b">Design and 3D print bearing blocks</td>
        <td className="py-2 px-4 border-b">✅</td>
      </tr>
      <tr>
        <td className="py-2 px-4 border-b">Insert ball bearings into bearing blocks</td>
        <td className="py-2 px-4 border-b">✅</td>
      </tr>
      <tr>
        <td className="py-2 px-4 border-b">Manufacture drive wheels with belt pulleys</td>
        <td className="py-2 px-4 border-b">✅</td>
      </tr>
      <tr>
        <td className="py-2 px-4 border-b">Laser-cut top and bottom plates</td>
        <td className="py-2 px-4 border-b">✅</td>
      </tr>
      <tr>
        <td className="py-2 px-4 border-b">Purchase and integrate drive shafts</td>
        <td className="py-2 px-4 border-b">✅</td>
      </tr>
      <tr>
        <td className="py-2 px-4 border-b">Develop first version of control app</td>
        <td className="py-2 px-4 border-b">✅</td>
      </tr>
      <tr>
        <td className="py-2 px-4 border-b">Design and 3D print external casing</td>
        <td className="py-2 px-4 border-b">❌</td>
      </tr>
      <tr>
        <td className="py-2 px-4 border-b">Redesign motor driver PCB</td>
        <td className="py-2 px-4 border-b">❌</td>
      </tr>
      <tr>
        <td className="py-2 px-4 border-b">Redesign ultrasonic sensor PCB (GRV 4-pin)</td>
        <td className="py-2 px-4 border-b">❌</td>
      </tr>
      <tr>
        <td className="py-2 px-4 border-b">Integrate power supply and voltage regulation</td>
        <td className="py-2 px-4 border-b">❌</td>
      </tr>
    </tbody>
  </table>
</div>


<h2 className="text-2xl font-bold text-left mb-6">Spiral Development Plan</h2>
<p className="text-justify text-gray-700 mb-4">
  The development of the Robo-Buddy is structured in iterative stages, each one delivering a working prototype and building toward the final functionality.
</p>
<img
            src={spiralDev}
            alt="SpiralDevelopment"
            className="rounded-lg shadow-md max-w-full h-auto"
          />

<ol className="list-decimal pl-6 text-gray-700 mb-6">
  <li>
    <strong>Spiral 1 – Core Mechanics:</strong> Assembly of chassis, drive shafts, wheels, and bearing blocks. Ensure stable movement and structural integration.
  </li>
  <li>
    <strong>Spiral 2 – Basic Control:</strong> Implement remote control functionality using the smartphone app. Test basic movement: forward, backward, turn.
  </li>
  <li>
    <strong>Spiral 3 – Sensor Integration:</strong> Add and test obstacle detection using ultrasonic sensors using I2C between boards.
  </li>
  <li>
    <strong>Spiral 4 – Power System:</strong> Add final power supply, including voltage regulation and battery integration. Test full mobility.
  </li>
  <li>
    <strong>Spiral 5 – Enclosure & Aesthetics:</strong> 3D model and print the robot shell and integrate the dome, mounting slots, and covers.
  </li>
  <li>
    <strong>Spiral 6 – Final Debug & Optimization:</strong> Refine PCBs, clean wiring, stress-test interaction between modules, and prepare final documentation.
  </li>
  <li>
    <strong>Spiral 7 – Add additional features</strong> Add features like RF- Follow Me - Mode. 
  </li>
</ol>




<h3 className="text-2xl font-bold text-left mb-4">What has been done?</h3>
<table className="table-auto w-full text-left border-collapse mb-6">
  <thead>
    <tr className="bg-gray-200">
      <th className="px-4 py-2">Status</th>
      <th className="px-4 py-2">Task</th>
    </tr>
  </thead>
  <tbody className="text-gray-700">
    <tr><td className="px-4 py-2">✅</td><td className="px-4 py-2">Bearing blocks 3D printed</td></tr>
    <tr><td className="px-4 py-2">✅</td><td className="px-4 py-2">Chassis plates laser-cut</td></tr>
    <tr><td className="px-4 py-2">✅</td><td className="px-4 py-2">First PCB for ultrasonic sensors milled</td></tr>
    <tr><td className="px-4 py-2">✅</td><td className="px-4 py-2">Drive shafts and wheels integrated</td></tr>
    <tr><td className="px-4 py-2">✅</td><td className="px-4 py-2">Mobile app prototype functional</td></tr>
  </tbody>
</table>


<h3 className="text-2xl font-bold text-left mb-4">What remains?</h3>
<table className="table-auto w-full text-left border-collapse mb-6">
  <thead>
    <tr className="bg-gray-200">
      <th className="px-4 py-2">Status</th>
      <th className="px-4 py-2">Task</th>
    </tr>
  </thead>
  <tbody className="text-gray-700">
    <tr><td className="px-4 py-2">❌</td><td className="px-4 py-2">Final mounting of the mechanical components</td></tr>
    <tr><td className="px-4 py-2">❌</td><td className="px-4 py-2">Design and print enclosure/dome</td></tr>
    <tr><td className="px-4 py-2">❌</td><td className="px-4 py-2">Final version of PCBs with proper connectors</td></tr>
    <tr><td className="px-4 py-2">❌</td><td className="px-4 py-2">Power system and battery integration</td></tr>
    <tr><td className="px-4 py-2">❌</td><td className="px-4 py-2">Test and debug all integrated components</td></tr>
    <tr><td className="px-4 py-2">❌</td><td className="px-4 py-2">Final documentation & videos</td></tr>
  </tbody>
</table>

<h3 className="text-2xl font-bold text-left mb-4">What has worked? What hasn’t?</h3>
<p className="text-justify text-gray-700 mb-6">
All individual components that have been tested so far are functioning as intended. Some wiring issues lead to the need to redesign the PCBs.
</p>

<h3 className="text-2xl font-bold text-left mb-4">What will happen when?</h3>
<p className="text-justify text-gray-700 mb-6">
  Over the next 2–3 weeks, all remaining components will be finalized in a spiral development fashion. 
  <ul>Week 1: Mounting parts and PCB manufacturing </ul>
  <ul>Week 2: Power integration and printing enclosure. </ul>
  <ul>Week 3: debug, polish, document.</ul>
</p>

<h3 className="text-2xl font-bold text-left mb-4">What have you learned?</h3>
<p className="text-justify text-gray-700 mb-6">
  Building a modular robot from scratch has taught me how to break complex systems into testable components. I’ve deepened my understanding of electronics production, microcontroller programming, and the value of iterative prototyping.
</p>

      </div>
    );
  };
  
  export default Assignment18;